module.exports = __webpack_public_path__ + "static/media/chevron_solid_white.e6886ec8.svg";